import React from 'react';
import { ArrowRight, ExternalLink, Phone, Calendar, Mail } from 'lucide-react';
import { finalCTA, siteConfig } from '../../data/mock';

const FinalCTASection = () => {
  return (
    <section id="contact" className="bg-black text-white">
      {/* Main CTA */}
      <div className="px-6 lg:px-12 xl:px-20 py-20 lg:py-32">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium leading-tight mb-12">
            {finalCTA.title}
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-16">
            {/* Preview Link Card */}
            <div className="p-8 bg-white/5 border border-white/10 text-left hover:bg-white/10 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <ExternalLink className="w-6 h-6 text-accent-green" />
                <h3 className="text-xl font-medium">{finalCTA.options[0].title}</h3>
              </div>
              <p className="text-white/60 mb-6">
                {finalCTA.options[0].description}
              </p>
              <button className="inline-flex items-center gap-2 text-accent-green hover:text-accent-green/80 font-medium transition-colors">
                Check your email
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>

            {/* Book a Call Card */}
            <div className="p-8 bg-accent-orange text-left hover:bg-accent-orange/90 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <Calendar className="w-6 h-6 text-black" />
                <h3 className="text-xl font-medium text-black">{finalCTA.options[1].title}</h3>
              </div>
              <p className="text-black/70 mb-6">
                {finalCTA.options[1].description}
              </p>
              <button className="inline-flex items-center gap-2 bg-black text-white px-6 py-3 font-medium hover:bg-black/80 transition-colors">
                Book Your Call
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-8 mb-16">
            <a
              href={`tel:${siteConfig.phone}`}
              className="flex items-center gap-2 text-white/60 hover:text-white transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span>{siteConfig.phone}</span>
            </a>
            <a
              href={`mailto:${siteConfig.email}`}
              className="flex items-center gap-2 text-white/60 hover:text-white transition-colors"
            >
              <Mail className="w-5 h-5" />
              <span>{siteConfig.email}</span>
            </a>
          </div>
        </div>
      </div>

      {/* Tagline Bar */}
      <div className="bg-accent-green py-12 px-6 lg:px-12 text-center">
        <p className="text-2xl md:text-3xl lg:text-4xl font-medium text-black mb-2">
          {finalCTA.tagline}
        </p>
        <p className="text-lg text-black/70">{finalCTA.subTagline}</p>
      </div>
    </section>
  );
};

export default FinalCTASection;
